module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_10.874bf914.png";